import { useOnce } from '@prophecy/utils/react/hooks';

import { makeGetCall } from '../data/util';
import { hostUrl } from '../utils/getServerUrl';
import { useAppMetadata } from './appMetadata';
import { EnabledTranspilers } from './types';

import type { FileFormats } from '@common/Transpiler/types';
import type { BackEndCodeLanguage } from '@prophecy/graphql-types/enums';

export function fetchEnabledTranspilers() {
  return (
    makeGetCall(hostUrl + '/api/feature/featuremgmt/enabledtranspiler') as Promise<{
      data: EnabledTranspilers;
      success: boolean;
    }>
  ).then((res) => (res.success ? res.data : DefaultEnabledTranspilers));
}

export const DefaultEnabledTranspilers: EnabledTranspilers = {};

export const useEnabledTranspilersAndLanguages = () => {
  const appMetadata = useAppMetadata();
  const supportedTranspilersRes = appMetadata.enabledTranspilers;
  return useOnce(() => {
    const supportedTranspilerType: FileFormats[] = [];
    const supportedLanguages: BackEndCodeLanguage[] = [];
    const transpilerToLanguageMap: Partial<Record<FileFormats, Set<BackEndCodeLanguage>>> = {};

    supportedTranspilersRes?.transpiler?.forEach((transpiler) => {
      supportedTranspilerType.push(transpiler.transpilerType);
      supportedLanguages.push(...transpiler.targetLanguage);
      transpilerToLanguageMap[transpiler.transpilerType] = new Set(transpiler.targetLanguage);
    });

    return {
      supportedTranspilerType: supportedTranspilerType.length
        ? new Set(supportedTranspilerType as FileFormats[])
        : null,
      supportedLanguages: supportedLanguages.length ? new Set(supportedLanguages as BackEndCodeLanguage[]) : null,
      transpilerToLanguageMap: Object.keys(transpilerToLanguageMap).length
        ? (transpilerToLanguageMap as Partial<Record<FileFormats, Set<BackEndCodeLanguage>>>)
        : null
    };
  });
};
